/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import Spinner from '../components/spinner';
import { toast } from 'react-toastify';

const Invoice = ({ cgtmseAns, sollarPower, handleBack, handleNext, files, setFiles, invoicePreId }) => {
    const [data, setData] = useState();
    const location = useLocation();
    const { state } = location;
    const projectId = localStorage.getItem('projectId');
    const invoiceId = localStorage.getItem('documentId')
    const [isLoading, setIsLoading] = useState(false);
    const [documentId, setDocumentId] = useState('')

    const handleFileChange = async (fieldName, e) => {
        try {
            const [file] = e.target.files;

            setFiles((prevFiles) => ({
                ...prevFiles,
                [fieldName]: file,
            }));

            const formData = new FormData();
            formData.append('projectId', projectId || state?.projectId);
            formData.append('projectMachineFrom', data?.machineFrom);
            formData.append(fieldName, file);
            if (invoiceId === null && documentId === '') {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/create-invoice`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('signIn')}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                if (response.status === 201) {
                    localStorage.setItem('documentId', response.data.result.id);
                    e.target.value = null;
                    handleEditData();
                }
            } else {

                const response = await axios.put(
                    `${process.env.REACT_APP_API_URL}/update-invoice/${documentId || invoiceId}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('signIn')}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                console.log(response);
                if (response.status === 201) {
                    localStorage.setItem('documentId', response.data.result.id);
                    e.target.value = null;
                    handleEditData();
                }
            }
        } catch (error) {
            console.error('Error handling file change:', error);
        }
    };

    const handleNextInvoice = async () => {
        handleNext();
    }
    const handleData = async () => {
        try {
            if (state?.projectId === undefined) {
                const projectResponse = await axios.get(
                    `${process.env.REACT_APP_API_URL}/get-project-byId/${projectId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('signIn')}`
                        }
                    }
                );
                const projects = projectResponse.data.result[0];
                setData(projects);
            } else {
                const projectResponse = await axios.get(
                    `${process.env.REACT_APP_API_URL}/get-project-byId/${state?.projectId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('signIn')}`
                        }
                    }
                );
                const projects = projectResponse.data.result[0];
                setData(projects);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleEditData = async () => {
        try {
            const invoiceResponse = await axios.get(
                `${process.env.REACT_APP_API_URL}/get-all-invoice`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('signIn')}`
                    }
                }
            );

            console.log(state?.projectId);
            const filteredDocuments = invoiceResponse.data.result.filter(
                (val) =>
                    val.projectId === (JSON.parse(projectId) || state?.projectId)
            );
            if (filteredDocuments.length > 0) {
                const record = filteredDocuments[filteredDocuments.length - 1];
                setDocumentId(record.id);
                setFiles({
                    commercial_invoice: record.commercial_invoice,
                    machine_bill:record.machine_bill,
                    packing_list: record.packing_list,
                    bill_landing: record.bill_landing,
                    certificate_origin: record.certificate_origin,
                    bill_entry: record.bill_entry,
                    machine_payreceipt: record.machine_payreceipt,
                    transfer_receipt: record.transfer_receipt,
                    tr6_challan: record.tr6_challan,
                    tax_invoice: record.tax_invoice,
                    payment_receipt: record.payment_receipt,
                    iem_registration: record.iem_registration,
                    pan_card: record.pan_card,
                    partnership_deed: record.partnership_deed,
                    registration_firm: record.registration_firm,
                    sale_rent_copy: record.sale_rent_copy,
                    audit_report: record.audit_report,
                    gst_Certificate: record.gst_Certificate,
                    existing_list: record.existing_list,
                    vera_bill: record.vera_bill,
                    digital_signature: record.digital_signature,
                    gpcb_copy: record.gpcb_copy,
                    cgtmse_letter: record.cgtmse_letter,
                    meter_sealing: record.meter_sealing,
                    project_completion: record.project_completion,
                    bank_appraisal: record.bank_appraisal,
                    sanction_letter: record.sanction_letter,
                    term_loan_statement: record.term_loan_statement,
                    current_loan_statement: record.current_loan_statement
                });
            } else {
                console.log('No records available.');
            }
        } catch (error) {
            console.error('Error fetching invoice data:', error);
        }
    };

    const handleDeleteInvoice = async (fieldName) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/delete-invoice/${fieldName}/${documentId || invoiceId}`);
            if (response.status === 201) {
                localStorage.setItem('documentId', response.data.result.id);
                toast.success(response.data.message);
                handleEditData();
                setFiles((prevFiles) => ({
                    ...prevFiles,
                    [fieldName]: ''
                }));

                await axios.put(`${process.env.REACT_APP_API_URL}/edit-invoice/${documentId || invoiceId}`,
                    { fieldName: fieldName, value: '' },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('signIn')}`
                        }
                    }
                );
            }
        } catch (error) {
            console.error('Error submitting invoice data:', error);
        }
    };

    useEffect(() => {
        handleData();
    }, [projectId]);

    useEffect(() => {
        handleEditData()
    }, [data, state, projectId, invoiceId])
    return (
        <div>
            {isLoading ? (
                <Spinner />
            ) : (
                <div className='container card card-body'>
                    <form>
                        <div className='row'>
                            {data?.machineFrom === 'imported' ? (
                                <>
                                <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Machine Bill</label>
                                                <input
                                                    type='file'
                                                    className='form-control'
                                                    onChange={(e) => handleFileChange('machine_bill', e)}
                                                />
                                                {files.machine_bill && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('machine_bill')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.machine_bill instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.machine_bill)} target="_blank" rel="noopener noreferrer">
                                                                {files.machine_bill?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.machine_bill} target="_blank" rel="noopener noreferrer">
                                                                {files.machine_bill?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Commercial Invoice with Machine Serial Number & Model No</label>
                                                <input
                                                    type='file'
                                                    className='form-control'
                                                    onChange={(e) => handleFileChange('commercial_invoice', e)}
                                                />
                                                {files.commercial_invoice && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('commercial_invoice')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.commercial_invoice instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.commercial_invoice)} target="_blank" rel="noopener noreferrer">
                                                                {files.commercial_invoice?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.commercial_invoice} target="_blank" rel="noopener noreferrer">
                                                                {files.commercial_invoice?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Packaging List with Machine Serial Number</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('packing_list', e)} />
                                                {files.packing_list && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('packing_list')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.packing_list instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.packing_list)} target="_blank" rel="noopener noreferrer">
                                                                {files.packing_list?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.packing_list} target="_blank" rel="noopener noreferrer">
                                                                {files.packing_list?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Bill of Landing</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('bill_landing', e)} />
                                                {files.bill_landing && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('bill_landing')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.bill_landing instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.bill_landing)} target="_blank" rel="noopener noreferrer">
                                                                {files.bill_landing?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.bill_landing} target="_blank" rel="noopener noreferrer">
                                                                {files.bill_landing?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Certificate of Origin</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('certificate_origin', e)} />
                                                {files.certificate_origin && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('certificate_origin')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>

                                                        {files.certificate_origin instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.certificate_origin)} target="_blank" rel="noopener noreferrer">
                                                                {files.certificate_origin?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.certificate_origin} target="_blank" rel="noopener noreferrer">
                                                                {files.certificate_origin?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Bill of Entry</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('bill_entry', e)} />
                                                {files.bill_entry && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('bill_entry')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.bill_entry instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.bill_entry)} target="_blank" rel="noopener noreferrer">
                                                                {files.bill_entry?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.bill_entry} target="_blank" rel="noopener noreferrer">
                                                                {files.bill_entry?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Machinery Payment Receipt(State)</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('machine_payreceipt', e)} />
                                                {files.machine_payreceipt && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('machine_payreceipt')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.machine_payreceipt instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.machine_payreceipt)} target="_blank" rel="noopener noreferrer">
                                                                {files.machine_payreceipt?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.machine_payreceipt} target="_blank" rel="noopener noreferrer">
                                                                {files.machine_payreceipt?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Swift/LC/RTGS/NEFT/Cheque/DD/PO transfer Receipt</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('transfer_receipt', e)} />
                                                {files.transfer_receipt && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('transfer_receipt')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>

                                                        {files.transfer_receipt instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.transfer_receipt)} target="_blank" rel="noopener noreferrer">
                                                                {files.transfer_receipt?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.transfer_receipt} target="_blank" rel="noopener noreferrer">
                                                                {files.transfer_receipt?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>TR 6 Challan (if Custom Duty Paid)</label>
                                                <input type='file' className='form-control' onChange={(e) => handleFileChange('tr6_challan', e)} />
                                                {files.tr6_challan && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('tr6_challan')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.tr6_challan instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.tr6_challan)} target="_blank" rel="noopener noreferrer">
                                                                {files.tr6_challan?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.tr6_challan} target="_blank" rel="noopener noreferrer">
                                                                {files.tr6_challan?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Tax Invoice</label>
                                                <input type='file' className='form-control'
                                                    onChange={(e) => handleFileChange('tax_invoice', e)} />
                                                {files.tax_invoice && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('tax_invoice')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {files.tax_invoice instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.tax_invoice)} target="_blank" rel="noopener noreferrer">
                                                                {files.tax_invoice?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.tax_invoice} target="_blank" rel="noopener noreferrer">
                                                                {files.tax_invoice?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <label>Payment Receipt</label>
                                                <input type='file' className='form-control'
                                                    onChange={(e) => handleFileChange('payment_receipt', e)} />
                                                {files.payment_receipt && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('payment_receipt')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>

                                                        {files.payment_receipt instanceof Blob ? (
                                                            <a href={URL.createObjectURL(files.payment_receipt)} target="_blank" rel="noopener noreferrer">
                                                                {files.payment_receipt?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + files.payment_receipt} target="_blank" rel="noopener noreferrer">
                                                                {files.payment_receipt?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>IEM Registration Copy/Udhyog Aadhar copy/ Udhyam Registration Copy</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('iem_registration', e)} />
                                        {files.iem_registration && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('iem_registration')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.iem_registration instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.iem_registration)} target="_blank" rel="noopener noreferrer">
                                                        {files.iem_registration?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.iem_registration} target="_blank" rel="noopener noreferrer">
                                                        {files.iem_registration?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Pan Card & Aadhar Card of all Partners / Proprietor / Director</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('pan_card', e)} />
                                        {files.pan_card && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('pan_card')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.pan_card instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.pan_card)} target="_blank" rel="noopener noreferrer">
                                                        {files.pan_card?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.pan_card} target="_blank" rel="noopener noreferrer">
                                                        {files.pan_card?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Partnership Deed (if Partnership firm)/Memorandum (For Pvt. Ltd.)</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('partnership_deed', e)} />
                                        {files.partnership_deed && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('partnership_deed')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.partnership_deed instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.partnership_deed)} target="_blank" rel="noopener noreferrer">
                                                        {files.partnership_deed?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.partnership_deed} target="_blank" rel="noopener noreferrer">
                                                        {files.partnership_deed?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Registration of Firm. (if Partnership firm)</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('registration_firm', e)} />
                                        {files.registration_firm && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('registration_firm')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.registration_firm instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.registration_firm)} target="_blank" rel="noopener noreferrer">
                                                        {files.registration_firm?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.registration_firm} target="_blank" rel="noopener noreferrer">
                                                        {files.registration_firm?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Sale /Rent / Lease Deed & Index Copy</label>
                                        <input type='file' className='form-control'
                                            onChange={(e) => handleFileChange('sale_rent_copy', e)} />
                                        {files.sale_rent_copy && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('sale_rent_copy')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.sale_rent_copy instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.sale_rent_copy)} target="_blank" rel="noopener noreferrer">
                                                        {files.sale_rent_copy?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.sale_rent_copy} target="_blank" rel="noopener noreferrer">
                                                        {files.sale_rent_copy?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Audit Report Last 3Year / ITR copy of last 3 years (if Expansion Unit)</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('audit_report', e)} />
                                        {files.audit_report && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('audit_report')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.audit_report instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.audit_report)} target="_blank" rel="noopener noreferrer">
                                                        {files.audit_report?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.audit_report} target="_blank" rel="noopener noreferrer">
                                                        {files.audit_report?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>GST Certificate</label>
                                        <input type='file' className='form-control'
                                            onChange={(e) => handleFileChange('gst_Certificate', e)} />
                                        {files.gst_Certificate && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('gst_Certificate')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.gst_Certificate instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.gst_Certificate)} target="_blank" rel="noopener noreferrer">
                                                        {files.gst_Certificate?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.gst_Certificate} target="_blank" rel="noopener noreferrer">
                                                        {files.gst_Certificate?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Existing Machinery List (If Expansion Unit)</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('existing_list', e)} />
                                        {files.existing_list && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('existing_list')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.existing_list instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.existing_list)} target="_blank" rel="noopener noreferrer">
                                                        {files.existing_list?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.existing_list} target="_blank" rel="noopener noreferrer">
                                                        {files.existing_list?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Vera Bill (If Factory is Inside Municipal Zone) & Light Bill</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('vera_bill', e)} />
                                        {files.vera_bill && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('vera_bill')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.vera_bill instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.vera_bill)} target="_blank" rel="noopener noreferrer">
                                                        {files.vera_bill?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.vera_bill} target="_blank" rel="noopener noreferrer">
                                                        {files.vera_bill?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Digital Signature with Password (ATUFS)</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('digital_signature', e)} />
                                        {files.digital_signature && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('digital_signature')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.digital_signature instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.digital_signature)} target="_blank" rel="noopener noreferrer">
                                                        {files.digital_signature?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.digital_signature} target="_blank" rel="noopener noreferrer">
                                                        {files.digital_signature?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>GPCB Consent copy (If applicable)</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('gpcb_copy', e)} />
                                        {files.gpcb_copy && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('gpcb_copy')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.gpcb_copy instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.gpcb_copy)} target="_blank" rel="noopener noreferrer">
                                                        {files.gpcb_copy?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.gpcb_copy} target="_blank" rel="noopener noreferrer">
                                                        {files.gpcb_copy?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {
                                cgtmseAns == 'yes' &&
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body'>
                                            <label>CGTMSE Letter (If cover under term loan CGTMSE)</label>
                                            <input type='file' className='form-control'
                                                onChange={(e) => handleFileChange('cgtmse_letter', e)} />
                                            {files.cgtmse_letter && (
                                                <>
                                                    <i
                                                        className="bi bi-trash3 float-right"
                                                        onClick={() => handleDeleteInvoice('cgtmse_letter')}
                                                        style={{ cursor: 'pointer' }}>
                                                    </i>
                                                    {files.cgtmse_letter instanceof Blob ? (
                                                        <a href={URL.createObjectURL(files.cgtmse_letter)} target="_blank" rel="noopener noreferrer">
                                                            {files.cgtmse_letter?.name}
                                                        </a>
                                                    ) : (
                                                        <a href={process.env.REACT_APP_BASE_URL + files.cgtmse_letter} target="_blank" rel="noopener noreferrer">
                                                            {files.cgtmse_letter?.split('/').pop().split('-').pop()}
                                                        </a>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                sollarPower &&
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body'>
                                            <label>Meter Sealing Certificate Performa-15 & Sanction Load Letter (Not Applicable For Rented Premises)</label>
                                            <input type='file' className='form-control' onChange={(e) => handleFileChange('meter_sealing', e)} />
                                            {files.meter_sealing && (
                                                <>
                                                    <i
                                                        className="bi bi-trash3 float-right"
                                                        onClick={() => handleDeleteInvoice('meter_sealing')}
                                                        style={{ cursor: 'pointer' }}>
                                                    </i>
                                                    {files.meter_sealing instanceof Blob ? (
                                                        <a href={URL.createObjectURL(files.meter_sealing)} target="_blank" rel="noopener noreferrer">
                                                            {files.meter_sealing?.name}
                                                        </a>
                                                    ) : (
                                                        <a href={process.env.REACT_APP_BASE_URL + files.meter_sealing} target="_blank" rel="noopener noreferrer">
                                                            {files.meter_sealing?.split('/').pop().split('-').pop()}
                                                        </a>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Project Report Verified by Bank</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('project_completion', e)} />
                                        {files.project_completion && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('project_completion')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.project_completion instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.project_completion)} target="_blank" rel="noopener noreferrer">
                                                        {files.project_completion?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.project_completion} target="_blank" rel="noopener noreferrer">
                                                        {files.project_completion?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Bank Appraisal Report</label>
                                        <input type='file' className='form-control'
                                            onChange={(e) => handleFileChange('bank_appraisal', e)} />
                                        {files.bank_appraisal && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('bank_appraisal')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.bank_appraisal instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.bank_appraisal)} target="_blank" rel="noopener noreferrer">
                                                        {files.bank_appraisal?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.bank_appraisal} target="_blank" rel="noopener noreferrer">
                                                        {files.bank_appraisal?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Sanction Letter</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('sanction_letter', e)} />
                                        {files.sanction_letter && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('sanction_letter')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.sanction_letter instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.sanction_letter)} target="_blank" rel="noopener noreferrer">
                                                        {files.sanction_letter?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.sanction_letter} target="_blank" rel="noopener noreferrer">
                                                        {files.sanction_letter?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Term Loan Statement</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('term_loan_statement', e)} />
                                        {files.term_loan_statement && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('term_loan_statement')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.term_loan_statement instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.term_loan_statement)} target="_blank" rel="noopener noreferrer">
                                                        {files.term_loan_statement?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.term_loan_statement} target="_blank" rel="noopener noreferrer">
                                                        {files.term_loan_statement?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <label>Current A/C.</label>
                                        <input type='file' className='form-control' onChange={(e) => handleFileChange('current_loan_statement', e)} />
                                        {files.current_loan_statement && (
                                            <>
                                                <i
                                                    className="bi bi-trash3 float-right"
                                                    onClick={() => handleDeleteInvoice('current_loan_statement')}
                                                    style={{ cursor: 'pointer' }}>
                                                </i>
                                                {files.current_loan_statement instanceof Blob ? (
                                                    <a href={URL.createObjectURL(files.current_loan_statement)} target="_blank" rel="noopener noreferrer">
                                                        {files.current_loan_statement?.name}
                                                    </a>
                                                ) : (
                                                    <a href={process.env.REACT_APP_BASE_URL + files.current_loan_statement} target="_blank" rel="noopener noreferrer">
                                                        {files.current_loan_statement?.split('/').pop().split('-').pop()}
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
                            <div className='form-group text-center'>
                                <button type='button'
                                    style={{ border: '1px solid gray', marginRight: '10px' }}
                                    className='btn btn-default btn res-btn-gray'
                                    onClick={() => handleBack()}
                                >
                                    Previous
                                </button>
                                <button
                                    type='button'
                                    style={{ border: '1px solid gray' }}
                                    className='btn btn-default col-xs-offset-1'
                                    onClick={handleNextInvoice}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            )}
        </div>
    )
}

export default Invoice